import { styled } from '@frontend/theme';
import { Box as MUIBox, Divider } from '@mui/material';

export const Step = styled(MUIBox)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  width: '100%',
}));

export const StepContent = styled(MUIBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
  width: '100%',
}));

export const StepHeadingWrapper = styled(MUIBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
  width: '100%',
}));

export const StepNumber = styled(MUIBox, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '24px',
  width: '100%',
  minHeight: '24px',
  borderRadius: '50%',
  boxSizing: 'border-box',
  color: active ? theme.palette.common.white : theme.palette.primary[500],
  backgroundColor: active
    ? theme.palette.primary[500]
    : theme.palette.common.white,
  transition: 'all .3s ease-out',
  border: `2.5px solid ${theme.palette.primary[500]}`,
  zIndex: 1,
}));

export const StepListWrapper = styled(MUIBox)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  width: '100%',
}));

export const StepsVerticalLine = styled(Divider)(({ theme }) => ({
  position: 'absolute',
  left: '11px',
  top: '1px',
  width: '2px',
  height: '98%',
  backgroundColor: theme.palette.primary[200],
  [theme.breakpoints.down('tablet')]: {
    height: '90%',
  },
}));

export const Wrapper = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '20px',
  background: theme.palette.common.white,
  boxShadow: theme.shadows[3],
  padding: '24px 32px 40px 32px',
  width: '100%',
}));
